var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box-count"},[_c('count-tax',{attrs:{"win-width":_vm.winWidth,"is-mobile-width":_vm.isMobileWidth},on:{"refreshData":_vm.updateDataList}})],1),_vm._v(" "),_c('div',{staticClass:"box-details"},[_c('tax-details',{attrs:{"data-list":_vm.dataList,"is-mobile-width":_vm.isMobileWidth}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3cbc72c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = null
// module chunks = 